import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { motion } from 'framer-motion';

const Index = () => {
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-text-container">
            <motion.div
              className="hero-text-container"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8 }}
            >
              <div className="location-line">
                <span className="location-text">PAPADAM</span>
              </div>
              
              <div className="cuisine-specialty">
                <h2 className="cuisine-title">Indische Spezialitäten</h2>
              </div>
              
              <div className="action-buttons">
                <Link to="/booking" className="action-btn reserve-btn">
                  Reservierung
                </Link>
                <Link to="/orders" className="action-btn order-btn">
                  Essen bestellen
                </Link>
              </div>
            </motion.div>
          </div>
          
          <div className="opening-hours">
            <ul className="hours-list">
              <span className="days">Dienstag - Sonntag:</span>
              <li className="hours-row">
                <span className="times">11:00–14:00 UHR</span>
                <span className="times"> , 17:00–22:00 UHR</span>
              </li>
              <span className="days">Montag:</span><br/>
              <span className="times">RUHETAG</span>
            </ul>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <div className="about-grid">
            <div className="side-image-container">
              <img
                src="https://images.unsplash.com/photo-1601050690597-df0568f70950?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c2Ftb3NhfGVufDB8fDB8fHww"
                alt="Indian spices"
                className="side-image"
              />
              <div className="image-overlay"></div>
            </div>

            <div className="about-content">
              <div className="section-header">
                <span className="section-subtitle">Entdecke</span>
                <h2 className="section-title">Indische Küche in Pfullendorf</h2>
              </div>
              <p className="welcome-text">Sehr geehrte Gäste!</p>
              <p className="about-description">
                Das Team des Restaurants „PAPADAM" heißt Sie herzlich willkommen! Lassen Sie sich von unserem authentischen Ambiente in Pfullendorf verzaubern und erleben Sie hervorragende, indische Gastfreundschaft. Unsere Gerichte werden ausschließlich mit frischen Zutaten und immer mit einer großen Portion Liebe zubereitet. Ein ausgezeichneter Mittagsbuffe und eine wechselnde Tageskarte lassen keine Wünsche offen.
              </p>
        
              <div className="signature-container">
                <p className="about-signature">– Ihre Familie Motty</p>
              </div>
            </div>

            <div className="side-image-container">
              <img
                src="https://images.unsplash.com/photo-1753357303396-704b5abe8945?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fHBhdiUyMGJoYWppfGVufDB8fDB8fHww"
                alt="Indian chefs"
                className="side-image"
              />
              <div className="image-overlay"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Three Boxes Section */}
      <section className="three-boxes-section">
        <div className="background-overlay"></div>
        <div className="container">
          <div className="boxes-container">
            <div className="boxes-grid">
              <div className="info-box">
                <div className="box-icon">
                  <span className="icon-leaf">🌳</span>
                </div>
                <div className="box-header">
                  <h3 className="box-title">Vegtarische/Vegan Gerichte</h3>
                </div>
                <p className="box-description">
                  Natürlich haben wir auch an unsere Vegtarische/veganen Gäste gedacht! Neuerdings haben wir eine Vielzahl an köstlichen,Vegtarische/Vegan Gerichten in unsere Speisekarte aufgenommen
                </p>
                <div className="box-divider"></div>
                <Link to="/menu?category=vegan" className="box-link">
                  Vegtarische/Vegan Speisekarte →
                </Link>
              </div>

              <div className="info-box highlight-box">
                <div className="box-icon">
                  <div className="box-icons"></div>
                  <span className="icon-leaf">🍲</span>
                </div>
                <div className="box-header">
                  <h3 className="box-title">Indische Spezialitäten</h3>
                </div>
                <p className="box-description">
                  Besonders stolz sind wir auf unsere authentischen Tandoori-Gerichte. Fleisch und Gemüse werden mit zahlreichen Gewürzen mariniert und auf offener Flamme im Lehmofen gebraten.
                </p>
                <div className="box-divider"></div>
                <Link to="/" className="box-link">
                  Zur Galerie →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Menu Section */}
<section className="menu-section">
  <div className="menu-background-image"></div>
  <div className="menu-overlay"></div>
  <div className="container">
<div className="menu-banner-wrapper">
  <h2 className="menu-main-title">DER GESCHMACK INDISCHER GEWÜRZE</h2>
</div>

<div className="section-header">
  <div className="menu-divider"></div>
  <p className="section-subtitle">Ein Einblick in kulinarische Köstlichkeiten</p>
</div>


    
    <div className="menu-categories-container">
      {/* Vegetarian/Vegan Column */}
      <div className="menu-categorys">
        <h3 className="category-title">Vegetarisch/Vegan</h3> 
       
        <div className="menu-items">
          <div className="menu-item-text">
            <div className="item-header">
              <span className="item-numbers">151</span>
              <span className="item-name">Dal Tadka (D G 14)</span>
              <span className="item-price">15.90 €</span>
            </div>
            <p className="item-descriptions">gebratene Linsen, zubereitet mit Zwiebeln, Ingwer, Knoblauch und Gewürzen .</p>
          </div>
          
          <div className="menu-item-text">
            <div className="item-header">
              <span className="item-numbers">152</span>
              <span className="item-name">Dal Makhani (D G 14) </span>
              <span className="item-price">15.90 €</span>
            </div>
            <p className="item-descriptions">Schwarze Linsen gekocht mit Butter, Ingwer, Tomaten & Currysoße  .</p>
          </div>
          
          <div className="menu-item-text">
            <div className="item-header">
              <span className="item-numbers">153</span>
              <span className="item-name">Mango Sabzi (B G H 14)</span>
              <span className="item-price">15.90 €</span>
            </div>
            <p className="item-descriptions">frisches Gemuse in Mango Currysoße  .</p>
          </div>
        </div>
      </div>
      
      {/* Poultry Column */}
      <div className="menu-categorys">
        <h3 className="category-title">Hähnchengerichte</h3>
        <div className="menu-items">
          <div className="menu-item-text">
            <div className="item-header">
              <span className="item-numbers">201</span>
              <span className="item-name">Chicken Saag (D G 14)</span>
              <span className="item-price">16.90 €</span>
            </div>
            <p className="item-descriptions">Hähnchenbrustfiletstücke mit Gewürzen in Spinatsoße  .</p>
          </div>
          
          <div className="menu-item-text">
            <div className="item-header">
              <span className="item-numbers">202</span>
              <span className="item-name"> Chicken Curry (D G 14)</span>
              <span className="item-price">16.90 €</span>
            </div> 
            <p className="item-descriptions"> Hähnchenfleisch mit Gewürzen in Currysoße  .</p>
          </div>
          
          <div className="menu-item-text">
            <div className="item-header">
              <span className="item-numbers">203</span>
              <span className="item-name">Mango Chicken  (BGH14)</span>
              <span className="item-price">16.90 €</span>
            </div>
            <p className="item-descriptions">Hähnchenbrustfiletstücke in Mango Currysoße</p>
          </div>
        </div>
      </div>
      
      {/* Fish & Co. Column */}
      <div className="menu-categorys">
        <h3 className="category-title">Lammgerichte</h3>
        <div className="menu-items">
          <div className="menu-item-text">
            <div className="item-header">
              <span className="item-numbers">301</span>
              <span className="item-name">Lamm Saag (D G 14)</span>
              <span className="item-price">17.90 €</span>
            </div>
            <p className="item-descriptions">Lammfleisch mit Gewürzen in Spinatsoße  .</p>
          </div>
          
          <div className="menu-item-text">
            <div className="item-header">
              <span className="item-numbers">302</span>
              <span className="item-name">Lamm Curry (D G 14)</span>
              <span className="item-price">17.90 €</span>
            </div>
            <p className="item-descriptions">Lammfleisch mit Gewürzen in Currysoße  .</p>
          </div>
          
          <div className="menu-item-text">
            <div className="item-header">
              <span className="item-numbers">303</span>
              <span className="item-name">Mango Lamm (B G H 14)</span>
              <span className="item-price">17.90 €</span>
            </div>
            <p className="item-descriptions"> Lammfleischstücke in Mango Currysoße  </p>
          </div>
        </div>
      </div>
   <div className="menu-button-wrapper">
  <button className="view-full-menu-btn">
    <Link to="/menu" className="full-menu-link">Vollständiges Menü anzeigen</Link>
  </button>
</div>

    </div>
  </div>
</section>

      {/* Newsletter Section */}
      {/* <section className="newsletter-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">Bleiben Sie auf dem Laufenden</span>
            <h2 className="section-title">Abonnieren Sie unseren Newsletter</h2>
            <div className="divider"></div>
            <p className="newsletter-subtitle">
              Bleiben Sie über unsere Sonderangebote, Veranstaltungen und saisonalen Menüs auf dem Laufenden.
            </p>
          </div>
          
          <form className="newsletter-form">
            <div className="input-group">
              <input 
                type="email" 
                placeholder="Ihre E-Mail-Adresse" 
                className="newsletter-input"
                required
              />
              <button type="submit" className="newsletter-btn">
                Abonnieren ✉
              </button>
            </div>
            <small className="form-text">
              Wir geben Ihre E-Mail-Adresse niemals an Dritte weiter.
            </small>
          </form>
        </div>
      </section> */}
    </div>
  );
};

export default Index;

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import './Home.css';
// import { motion } from 'framer-motion';

// const Index = () => {
//   const [showPopup, setShowPopup] = useState(false);

//   useEffect(() => {
//     // Show popup when component mounts
//     setShowPopup(true);
//   }, []);

//   const closePopup = () => {
//     setShowPopup(false);
//   };

//   return (
//     <div className="home-container">
//       {/* Popup Modal */}
//       {showPopup && (
//         <div className="popup-overlay">
//           <motion.div 
//             className="popup-content"
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.3 }}
//           >
//             <div className="popup-header">
//               <h3 className="popup-title">Wichtige Information</h3>
//               <button className="popup-close" onClick={closePopup}>×</button>
//             </div>
//             <div className="popup-body">
//               <p className="popup-message">
//                 Das Restaurant wird am <strong>10. Oktober 2025</strong> eröffnet!
//               </p>
//               <p className="popup-submessage">
//                 Wir freuen uns darauf, Sie bald bei uns begrüßen zu dürfen!
//               </p>
//             </div>
//             <div className="popup-footer">
//               <button className="popup-confirm-btn" onClick={closePopup}>
//                 Verstanden
//               </button>
//             </div>
//           </motion.div>
//         </div>
//       )}

//       {/* Hero Section */}
//       <section className="hero-section">
//         <div className="hero-overlay"></div>
//         <div className="hero-content">
//           <div className="hero-text-container">
//             <motion.div
//               className="hero-text-container"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ duration: 0.8 }}
//             >
//               <div className="location-line">
//                 <span className="location-text">PAPADAM</span>
//               </div>
              
//               <div className="cuisine-specialty">
//                 <h2 className="cuisine-title">Indische Spezialitäten</h2>
//               </div>
              
//               <div className="action-buttons">
//                 <Link to="/booking" className="action-btn reserve-btn">
//                   Reservierung
//                 </Link>
//                 <Link to="/orders" className="action-btn order-btn">
//                   Essen bestellen
//                 </Link>
//               </div>
//             </motion.div>
//           </div>
          
//           <div className="opening-hours">
//             <ul className="hours-list">
//               <span className="days">Dienstag - Sonntag:</span>
//               <li className="hours-row">
//                 <span className="times">11:00–14:00 UHR</span>
//                 <span className="times"> , 17:00–22:00 UHR</span>
//               </li>
//               <span className="days">Montag:</span><br/>
//               <span className="times">RUHETAG</span>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* About Section */}
//       <section className="about-section">
//         <div className="container">
//           <div className="about-grid">
//             <div className="side-image-container">
//               <img
//                 src="https://images.unsplash.com/photo-1601050690597-df0568f70950?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c2Ftb3NhfGVufDB8fDB8fHww"
//                 alt="Indian spices"
//                 className="side-image"
//               />
//               <div className="image-overlay"></div>
//             </div>

//             <div className="about-content">
//               <div className="section-header">
//                 <span className="section-subtitle">Entdecke</span>
//                 <h2 className="section-title">Indische Küche in Pfullendorf</h2>
//               </div>
//               <p className="welcome-text">Sehr geehrte Gäste!</p>
//               <p className="about-description">
//                 Das Team des Restaurants „PAPADAM" heißt Sie herzlich willkommen! Lassen Sie sich von unserem authentischen Ambiente in Pfullendorf verzaubern und erleben Sie hervorragende, indische Gastfreundschaft. Unsere Gerichte werden ausschließlich mit frischen Zutaten und immer mit einer großen Portion Liebe zubereitet. Ein ausgezeichneter Mittagsbuffe und eine wechselnde Tageskarte lassen keine Wünsche offen.
//               </p>
        
//               <div className="signature-container">
//                 <p className="about-signature">– Ihre Familie Motty</p>
//               </div>
//             </div>

//             <div className="side-image-container">
//               <img
//                 src="https://images.unsplash.com/photo-1753357303396-704b5abe8945?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fHBhdiUyMGJoYWppfGVufDB8fDB8fHww"
//                 alt="Indian chefs"
//                 className="side-image"
//               />
//               <div className="image-overlay"></div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Three Boxes Section */}
//       <section className="three-boxes-section">
//         <div className="background-overlay"></div>
//         <div className="container">
//           <div className="boxes-container">
//             <div className="boxes-grid">
//               <div className="info-box">
//                 <div className="box-icon">
//                   <span className="icon-leaf">🌳</span>
//                 </div>
//                 <div className="box-header">
//                   <h3 className="box-title">Vegtarische/Vegan Gerichte</h3>
//                 </div>
//                 <p className="box-description">
//                   Natürlich haben wir auch an unsere Vegtarische/veganen Gäste gedacht! Neuerdings haben wir eine Vielzahl an köstlichen,Vegtarische/Vegan Gerichten in unsere Speisekarte aufgenommen
//                 </p>
//                 <div className="box-divider"></div>
//                 <Link to="/menu?category=vegan" className="box-link">
//                   Vegtarische/Vegan Speisekarte →
//                 </Link>
//               </div>

//               <div className="info-box highlight-box">
//                 <div className="box-icon">
//                   <div className="box-icons"></div>
//                   <span className="icon-leaf">🍲</span>
//                 </div>
//                 <div className="box-header">
//                   <h3 className="box-title">Indische Spezialitäten</h3>
//                 </div>
//                 <p className="box-description">
//                   Besonders stolz sind wir auf unsere authentischen Tandoori-Gerichte. Fleisch und Gemüse werden mit zahlreichen Gewürzen mariniert und auf offener Flamme im Lehmofen gebraten.
//                 </p>
//                 <div className="box-divider"></div>
//                 <Link to="/" className="box-link">
//                   Zur Galerie →
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Menu Section */}
//       <section className="menu-section">
//         <div className="menu-background-image"></div>
//         <div className="menu-overlay"></div>
//         <div className="container">
//           <div className="menu-banner-wrapper">
//             <h2 className="menu-main-title">DER GESCHMACK INDISCHER GEWÜRZE</h2>
//           </div>

//           <div className="section-header">
//             <div className="menu-divider"></div>
//             <p className="section-subtitle">Ein Einblick in kulinarische Köstlichkeiten</p>
//           </div>

//           <div className="menu-categories-container">
//             {/* Vegetarian/Vegan Column */}
//             <div className="menu-categorys">
//               <h3 className="category-title">Vegetarisch/Vegan</h3> 
             
//               <div className="menu-items">
//                 <div className="menu-item-text">
//                   <div className="item-header">
//                     <span className="item-numbers">151</span>
//                     <span className="item-name">Dal Tadka (D G 14)</span>
//                     <span className="item-price">14.90 €</span>
//                   </div>
//                   <p className="item-descriptions">gebratene Linsen, zubereitet mit Zwiebeln, Ingwer, Knoblauch und Gewürzen .</p>
//                 </div>
                
//                 <div className="menu-item-text">
//                   <div className="item-header">
//                     <span className="item-numbers">152</span>
//                     <span className="item-name">Dal Makhani (D G 14) </span>
//                     <span className="item-price">14.90 €</span>
//                   </div>
//                   <p className="item-descriptions">Schwarze Linsen gekocht mit Butter, Ingwer, Tomaten & Currysoße  .</p>
//                 </div>
                
//                 <div className="menu-item-text">
//                   <div className="item-header">
//                     <span className="item-numbers">153</span>
//                     <span className="item-name">Mango Sabzi (B G H 14)</span>
//                     <span className="item-price">15.90 €</span>
//                   </div>
//                   <p className="item-descriptions">frisches Gemuse in Mango Currysoße  .</p>
//                 </div>
//               </div>
//             </div>
            
//             {/* Poultry Column */}
//             <div className="menu-categorys">
//               <h3 className="category-title">Hähnchengerichte</h3>
//               <div className="menu-items">
//                 <div className="menu-item-text">
//                   <div className="item-header">
//                     <span className="item-numbers">201</span>
//                     <span className="item-name">Chicken Saag (D G 14)</span>
//                     <span className="item-price">16.90 €</span>
//                   </div>
//                   <p className="item-descriptions">Hähnchenbrustfiletstücke mit Gewürzen in Spinatsoße  .</p>
//                 </div>
                
//                 <div className="menu-item-text">
//                   <div className="item-header">
//                     <span className="item-numbers">202</span>
//                     <span className="item-name"> Chicken Curry (D G 14)</span>
//                     <span className="item-price">16.90 €</span>
//                   </div> 
//                   <p className="item-descriptions"> Hähnchenfleisch mit Gewürzen in Currysoße  .</p>
//                 </div>
                
//                 <div className="menu-item-text">
//                   <div className="item-header">
//                     <span className="item-numbers">203</span>
//                     <span className="item-name">Mango Chicken  (BGH14)</span>
//                     <span className="item-price">16.90 €</span>
//                   </div>
//                   <p className="item-descriptions">Hähnchenbrustfiletstücke in Mango Currysoße</p>
//                 </div>
//               </div>
//             </div>
            
//             {/* Fish & Co. Column */}
//             <div className="menu-categorys">
//               <h3 className="category-title">Lammgerichte</h3>
//               <div className="menu-items">
//                 <div className="menu-item-text">
//                   <div className="item-header">
//                     <span className="item-numbers">301</span>
//                     <span className="item-name">Lamm Saag (D G 14)</span>
//                     <span className="item-price">17.90 €</span>
//                   </div>
//                   <p className="item-descriptions">Lammfleisch mit Gewürzen in Spinatsoße  .</p>
//                 </div>
                
//                 <div className="menu-item-text">
//                   <div className="item-header">
//                     <span className="item-numbers">302</span>
//                     <span className="item-name">Lamm Curry (D G 14)</span>
//                     <span className="item-price">17.90 €</span>
//                   </div>
//                   <p className="item-descriptions">Lammfleisch mit Gewürzen in Currysoße  .</p>
//                 </div>
                
//                 <div className="menu-item-text">
//                   <div className="item-header">
//                     <span className="item-numbers">303</span>
//                     <span className="item-name">Mango Lamm (B G H 14)</span>
//                     <span className="item-price">17.90 €</span>
//                   </div>
//                   <p className="item-descriptions"> Lammfleischstücke in Mango Currysoße  </p>
//                 </div>
//               </div>
//             </div>
//             <div className="menu-button-wrapper">
//               <button className="view-full-menu-btn">
//                 <Link to="/menu" className="full-menu-link">Vollständiges Menü anzeigen</Link>
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Index;
